import { Action, bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";
import { StateType } from "../../../../utils/types";
import { setNextStep } from "../../../../redux/shared/actions";
import { getLesson, assignLesson } from "../../../../redux/educator/actions";
import {
  selectLessons,
  selectLessonLoading,
} from "../../../../redux/educator/selector";

const mapStateToProps = (state: StateType) => ({
  lessons: selectLessons(state),
  loading: selectLessonLoading(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators(
    {
      setNextStep,
      assignLesson,
      getLesson,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
